import * as api from '@/api'

const state = {

  pages_products: [],
  pages_products_loaded: false,



  base_cart: null,
  cart: [],
  cart_count: 0,
  payment_type: 0,
  is_pickup: 0,
  is_drive_trough: 0,
  pickup_address: null,
  data_source: null,
  app_link: null,
  order_id: null,
  message: "",
  ordered: false,
  orderhistory: null,
  rewardhistory: null,
  delivery_gps_data: null,
  last_order: [],
  delivery_address_text:"{}",
  get_cartid_result: [],
  get_cartid: "",
  update_account_result: [],
  cartid_is_ready: false,
  cart_is_signed_in: 0,
  current_reward_points: 0,
  environment: "",
  reward_order_response: [],

  send_promo_phone_number_result: [],

}
// getters
const getters = {


  pages_products: state => state.pages_products,
  pages_products_loaded: state => state.pages_products_loaded,

  send_promo_phone_number_result: state => state.send_promo_phone_number_result,


  isDebit: state => state.payment_type == 1 ? true : false,

  cartItems: (state) => {
    return state.cart
  },

  // Froot
  getEnvironment: (state) => {
    return state.environment;
  },

  // Froot
  getCart: (state) => {
    return state.base_cart;
  },


  // Froot
  reward_order_response: (state) => {
    return state.reward_order_response;
  },






  webTotalTitle: state=> state.base_cart && state.base_cart.web_total_title,
  webTotalLegalText:state=> state.base_cart && state.base_cart.web_total_legal_text,
  webTotalLegalUrl:state=> state.base_cart && state.base_cart.web_total_legal_url,
  webTotalLines: (state) => state.base_cart && state.base_cart.web_total_lines,
  cartTotalAmount: (state) => state.base_cart && state.base_cart.web_total_lines.find(e => e.type === 'ordertotal').value_show,
  subTotalAmount: state => state.base_cart && state.base_cart.web_total_lines.find(e => e.type === 'subtotal').value_show,
  taxAmount: state => state.base_cart && state.base_cart.web_total_lines.find(e => e.type === 'taxesfees').value_show,
  deliverAmount: state => state.base_cart && state.base_cart.web_total_lines.find(e => e.type === 'delivery').value_show,
  webTotalDetails: state => state.base_cart && state.base_cart.web_total_details,
  getOrderID: state => state.order_id,
  getOverallPromoCoupon: state => state.base_cart && state.base_cart.overall_promo_coupon,
  ordered: state => state.ordered,
  order_history: state => state.orderhistory,
  reward_history: state => state.rewardhistory,
  paymenttype: state => state.payment_type,
  is_pickup: state => state.is_pickup,
  is_drive_trough: state => state.is_drive_trough,
  data_source: state => state.data_source,
  delivery_gps_data: state => state.delivery_gps_data,
  pickup_address: state => state.pickup_address,
  getDeliveryAddress: state => JSON.parse(state.delivery_address_text),
  getBlockCheckout:  state => state.base_cart && state.base_cart.block_checkout,
  getFreeDeliveryText: state => state.base_cart && state.base_cart.get_free_delivery_text,
  getIsFreeDelivery: state => state.base_cart && state.base_cart.is_free_delivery,
  getWarningText: state => state.base_cart && state.base_cart.warning_text,
  get_cartid_result: state => state.get_cartid_result,
  get_cartid: state => state.get_cartid_result.cart_id,
  cartid_is_ready: state => state.cartid_is_ready,
  cart_is_signed_in: state => state.base_cart.issignedin,
  current_reward_points: state => state.current_reward_points,

}
// mutations
const mutations = {


  loadPagesProducts: (state, payload) => {
    state.pages_products_loaded = false
    api.loadPagesProducts( { 'authorization': payload.token }).then(val => {
      state.pages_products = val.data
      state.pages_products_loaded = true;
    })
  },





  setOrderhistory: (state, payload) => {
    state.orderhistory = payload.data
  },
  setRewardhistory: (state, payload) => {
    state.rewardhistory = payload.data
  },

  paymentSelect: (state, payload) => {
    api.updatePayment({ to_payment_type: payload.payment_type }, { 'authorization': payload.token }).then(val => {
      state.base_cart = val.data
      state.cart_count = val.data.cart_count
      state.cart = val.data.items
      state.payment_type = val.data.payment_type
      state.is_pickup = val.data.is_pickup
      state.is_drive_trough = val.data.is_drive_trough
      state.pickup_address = val.data.pickup_address
      state.data_source = "paymentSelect"
    })
  },
  setPickupDelivery: (state, payload) => {
    api.setPickupDelivery({is_pickup: payload.is_pickup }, { 'authorization': payload.token }).then(val => {
      state.base_cart = val.data
      state.cart_count = val.data.cart_count
      state.cart = val.data.items
      state.payment_type = val.data.payment_type
      state.is_pickup = val.data.is_pickup
      state.is_drive_trough = val.data.is_drive_trough
      state.pickup_address = val.data.pickup_address
      state.data_source = "setPickupDelivery"
    })
  },
  setDeliveryAddressText: (state, payload) => {
    state.delivery_address_text = payload.delivery_address_text;
  },
  updateDeliveryGPS: (state, payload) => {
    api.updateDeliveryGPS({
        }, { 'authorization': payload.token }
    ).then(res => {
      state.delivery_gps_data = res.data;
    })
  },



  order: (state, payload) => {
    api.shopingcartOrder({
      delivery_address_text: state.delivery_address_text,
      special_instructions_message: payload.special_instructions_message,
      location_id: payload.location_id,
    },
      { 'authorization': payload.token }
    ).then(res => {
      var order_status = res.data;
      state.order_id = order_status.order_id;
      state.ordered = true

      api.orderHistory({ order_id: state.order_id }, { 'authorization': payload.token }).then(val => {
        state.last_order = val.data
      })

    })

  },


  setAmountCartProductQuantity: (state, payload) => {
    api.setCartProductQuantity({ productid: payload.productid, quantity: payload.quantity }, { 'authorization': payload.token }).then(val => {
      var temp_cart_items = state.base_cart.items;
      state.base_cart = val.data;

      state.base_cart.items.forEach(item => {
        if (item.productid === payload.productid) {
          item.is_reward = true;
          item.is_amount = true;
        } else {
          var temp_item = temp_cart_items.find(x => x.productid === item.productid);
          item.is_reward = temp_item.is_reward;
          item.is_amount = temp_item.is_amount;
        }
      });
    })
  },

  setRewardCartProductQuantity: (state, payload) => {
    api.setCartProductQuantity({ productid: payload.productid, quantity: payload.quantity }, { 'authorization': payload.token }).then(val => {
      var temp_cart_items = state.base_cart.items;
      state.base_cart = val.data;

      state.base_cart.items.forEach(item => {
        if (item.productid === payload.productid) {
          item.is_reward = true;
          item.is_amount = false;
        } else {
          var temp_item = temp_cart_items.find(x => x.productid === item.productid);
          item.is_reward = temp_item.is_reward;
          item.is_amount = temp_item.is_amount;
        }
      });
    })
  },


  placeRewardOrder: (state, payload) => {
    api.placeRewardOrder({
      quantity: payload.quantity,
      sku: payload.sku,
      firstname: payload.firstname,
      lastname: payload.lastname,
      address: payload.address,
      city: payload.city,
      zipcode: payload.zipcode,
      state: payload.state,
      phone: payload.phone
    }, { 'authorization': payload.token }).then(val => {
      state.reward_order_response = val.data
    })
  },

  updateCartItemQty: (state, payload) => {
    api.updateShopingcart({ sku: payload.sku, qty: payload.qty}, { 'authorization': payload.token }).then(val => {
      state.base_cart = val.data
      state.cart_count = val.data.cart_count
      state.cart = val.data.items
      state.payment_type = val.data.payment_type
      state.is_pickup = val.data.is_pickup
      state.is_drive_trough = val.data.is_drive_trough
      state.pickup_address = val.data.pickup_address
    })
  },

  removeCartItem: (state, payload) => {
    api.updateShopingcart({ sku: payload.sku, qty: 0 }, { 'authorization': payload.token }).then(val => {
      state.base_cart = val.data
      state.cart_count = val.data.cart_count
      state.cart = val.data.items
      state.payment_type = val.data.payment_type
      state.is_pickup = val.data.is_pickup
      state.is_drive_trough = val.data.is_drive_trough
      state.pickup_address = val.data.pickup_address
    })
  },

  addPromoItem: (state, payload) => {
    api.addPromoItem({ sku: payload.sku, promo_id: payload.promo_id }, { 'authorization': payload.token }).then(val => {
      state.base_cart = val.data
      state.cart_count = val.data.cart_count
      state.cart = val.data.items
      state.payment_type = val.data.payment_type
      state.is_pickup = val.data.is_pickup
      state.is_drive_trough = val.data.is_drive_trough
      state.pickup_address = val.data.pickup_address
    })
  },




  setOverallPromoCode: (state, payload) => {
    api.setOverallPromoCode({ promocoupon: payload.promocoupon}, { 'authorization': payload.token }).then(val => {
      state.base_cart = val.data
      state.cart_count = val.data.cart_count
      state.cart = val.data.items
      state.payment_type = val.data.payment_type
      state.is_pickup = val.data.is_pickup
      state.is_drive_trough = val.data.is_drive_trough
      state.pickup_address = val.data.pickup_address
    })
  },
  updateAccountData: (state, payload) => {
    api.updateAccountData({ email: payload.email, phone: payload.phone }, { 'authorization': payload.token }).then(val => {
      state.update_account_result = val.data
    })
  },

  checkCartId: (state, payload) => {
    api.checkCartId({
      cartid: payload.cartid,
      browserstring: payload.browserstring,
    }, { 'authorization': payload.token }).then(val => {
      state.get_cartid_result = val.data
      if(val.data.isnew === 1) {
        localStorage.setItem('cartid', val.data.cart_id);
      }
      state.environment = val.data.environment;
      state.cartid_is_ready = true;
    })
  },

  loadShoppingCart: (state, payload) => {
    api.getShopingcart( { 'authorization': payload.token }).then(val => {
      state.base_cart = val.data
      state.cart_count = val.data.cart_count
      state.cart = val.data.items
      //...
      state.base_cart.items.forEach(element => {
        if (element.quantity > 0) {
          element.is_reward = true;
          element.is_amount = true;
        }
      });

      state.current_reward_points = val.data.current_reward_points
      state.payment_type = val.data.payment_type
      state.is_pickup = val.data.is_pickup
      state.is_drive_trough = val.data.is_drive_trough
      state.pickup_address = val.data.pickup_address
    })
  },

  sendPromoPhoneNumber: (state, payload) => {
    api.sendPromoPhoneNumber({
      text: payload.text,
    }, { 'authorization': payload.token }).then(val => {
      state.send_promo_phone_number_result = val.data
    })
  },









}
// actions
const actions = {

  loadPagesProducts: (context, payload) => {
    context.commit('loadPagesProducts', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },



  setAmountCartProductQuantity: (context, payload) => {
    context.commit('setAmountCartProductQuantity', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },

  setRewardCartProductQuantity: (context, payload) => {
    context.commit('setRewardCartProductQuantity', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },

  placeRewardOrder: (context, payload) => {
    context.commit('placeRewardOrder', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },




  ////////////

  setOrderhistory: (context, payload) => {
    context.commit('setOrderhistory', payload)
  },

  setRewardhistory: (context, payload) => {
    context.commit('setRewardhistory', payload)
  },

  order: (context, payload) => {
    context.commit('order', { ...payload, token: context.rootGetters['auth/getAccessToken'], appUser: context.rootState.auth.app_user })
  },
  setDeliveryAddressText: (context, payload) => {
    context.commit('setDeliveryAddressText', payload);
  },
  updateDeliveryGPS: (context, payload) => {
    context.commit('updateDeliveryGPS', { ...payload, token: context.rootGetters['auth/getAccessToken'], appUser: context.rootState.auth.app_user });
  },
  paymentSelect: (context, payload) => {
    context.commit('paymentSelect', { ...payload, token: context.rootGetters['auth/getAccessToken'], appUser: context.rootState.auth.app_user })
  },
  setPickupDelivery: (context, payload) => {
    context.commit('setPickupDelivery', { ...payload, token: context.rootGetters['auth/getAccessToken'], appUser: context.rootState.auth.app_user })
  },
  updateCartItemQty: (context, payload) => {
    context.commit('updateCartItemQty', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },
  removeCartItem: (context, payload) => {
    context.commit('removeCartItem', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },
  addPromoItem: (context, payload) => {
    context.commit('addPromoItem', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },
  setOverallPromoCode: (context, payload) => {
    context.commit('setOverallPromoCode', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },
  updateAccountData: (context, payload) => {
    context.commit('updateAccountData', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },

  checkCartId: (context, payload) => {
    context.commit('checkCartId', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },

  loadShoppingCart: (context, payload) => {
    context.commit('loadShoppingCart', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },

  sendPromoPhoneNumber: (context, payload) => {
    context.commit('sendPromoPhoneNumber', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
  },


}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
